export enum ApplySetupWhen {
    Daily = 1,
    IssueInvoice = 2,
    FinanceRelease = 3,
}